var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreauthorization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0194 0C7.53056 1.221 5.55556 2.2 0 3.3V9.779C0 17.1133 6.29722 20.779 10 22C13.7028 20.779 20 17.1105 20 9.779V3.3C14.4444 2.2 12.4694 1.221 10.0194 0ZM13.9361 9.383L9.49167 13.783C9.32778 13.9453 9.11667 14.025 8.90278 14.025C8.68889 14.025 8.475 13.9453 8.31389 13.783L6.09167 11.583C5.76667 11.2612 5.76667 10.7388 6.09167 10.417C6.41667 10.0953 6.94444 10.0953 7.26944 10.417L8.90278 12.034L12.7583 8.217C13.0833 7.89525 13.6111 7.89525 13.9361 8.217C14.2611 8.53875 14.2611 9.06125 13.9361 9.383Z",
    fill: "#2C2B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreauthorization);
export default __webpack_public_path__ + "static/media/preauthorization.ea6eb32b67dc15c1025d4acf15c2b7ba.svg";
export { ForwardRef as ReactComponent };